<template>
    <div data-app>
        <md-snackbar :md-active.sync="snackbar.show" :md-duration="8000">
      <span>
        <template v-if="snackbar.icon">
          <md-icon class="md-primary">{{ snackbar.icon }}</md-icon>
          &nbsp;&nbsp;&nbsp;
        </template>
        {{ snackbar.content }}
      </span>
            <md-button class="md-primary md-simple md-dense" @click="snackbar.show = false">Dismiss</md-button>
        </md-snackbar>
        <group-card title="Broker Details" icon="real_estate_agent" padded v-if="brokerData!='' || (this.brokerId==undefined)">
            <template slot="actions">
                <md-switch v-model="pageEditable">Edit Details</md-switch>
            </template>
            <ValidationObserver v-slot="{ invalid }">
              <form class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
                  <md-card-content>
                    <group-card icon="face" padded v-if="brokerData!='' || (this.brokerId==undefined)">
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <validated-text-input
                            label="Broker First Name"
                            v-model="brokerData.first_name"
                            :disabled="!pageEditable"
                            regex = "^[A-Za-z- ']+$"
                            errormsg="Please enter the correct information, only characters are accepted."
                          />
                        </div>
                        <div class="md-layout-item">
                          <validated-text-input
                            label="Broker Last Name"
                            v-model="brokerData.last_name"
                            :disabled="!pageEditable"
                            regex = "^[A-Za-z- ']+$"
                            errormsg="Please enter the correct information, only characters are accepted."
                          />
                        </div>
                        <div class="md-layout-item">
                          <validated-text-input
                            label="Preferred Name"
                            v-model="brokerData.prefered_name"
                            :disabled="!pageEditable"
                            regex="^\S+( \S+)*$"
                            errormsg="Only one space between words is allowed, leading or trailing spaces are not accepted."
                          />
                        </div>
                        <div class="md-layout-item">
                          <validated-text-input
                              label="Broker Email"
                              v-model="brokerData.broker_email"
                              melissaCheckType="email"
                              :disabled="!pageEditable"
                              @is-melissa-check-passed-changed="updateMelissaCheck"
                              :required="pageEditable"
                              ref="broker_email_input"
                          />
                        </div>
                        <div class="md-layout-item">
                          <validated-text-input
                              label="Personal Email"
                              v-model="brokerData.personal_email"
                              melissaCheckType="email"
                              :disabled="!pageEditable"
                              @is-melissa-check-passed-changed="updateMelissaCheck"
                              ref="personal_email_input"
                          />
                        </div>
                      </div>
                      <br>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item md-alignment-top-center">
                          <validated-text-input
                            label="Phone"
                            ref="phone_input"
                            v-model="brokerData.broker_phone"
                            :maxLength=10
                            :minLength=10
                            regex = "^\d+$"
                            errormsg="Please enter a valid phone number. The format should include only digits, and the length must be exactly ten digits."
                            melissaCheckType="phone"
                            :disabled="!pageEditable"
                            @is-melissa-check-passed-changed="updateMelissaCheck"
                          />
                        </div>
                        <div class="md-layout-item">
                          <validated-autocomplete-input
                            label="State" v-model="brokerData.state"
                            :options="states"
                            :disabled="!pageEditable"
                          />
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="emp-type">Employment Type</label>
                            <md-select
                              id="emp-type"
                              :disabled="!pageEditable"
                              v-model="brokerData.employment_type">
                              <md-option v-for="item in broker_employment_types" v-bind:key="item" :value="item">
                                {{ item }}
                              </md-option>
                            </md-select>
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="seating">Seating</label>
                            <md-select id="seating"
                              :disabled="!pageEditable"
                              v-model="brokerData.seating">
                                <md-option value="internal">Internal</md-option>
                                <md-option value="external">External</md-option>
                            </md-select>
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <validated-autocomplete-input
                            label="Pod" v-model="brokerData.user.user_pod.name"
                            :options="allPodsOptions"
                            :disabled="!pageEditable"
                            :required="true"
                          />
                        </div>
                        <div class="md-layout-item">
                          <validated-text-input
                            label="Postcode"
                            v-model="brokerData.postcode"
                            :disabled="!pageEditable"
                            regex="^\d{4}$"
                            errormsg="Postcode must be exactly 4 digits."
                          />
                        </div>
                      </div>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <md-field>
                            <label for="xero-contact-id">Xero Contact</label>
                            <md-input
                              id="xero-contact-id"
                              :disabled="!pageEditable"
                              v-model="xero_contacts.query"
                            />
                            <span class="md-suffix" v-if="xero_contacts.searching">
                              <md-progress-spinner
                                :md-diameter="30"
                                :md-stroke="3"
                                md-mode="indeterminate">
                              </md-progress-spinner>
                            </span>
                          </md-field>
                          <v-data-table
                            v-if="xero_contacts.results && xero_contacts.query"
                            :items="xero_contacts.results"
                            :headers="headers"
                            hide-default-header
                            item-key="id"
                            @click:row="handleClick"
                            hide-default-footer
                            class="elevation-1"
                          ></v-data-table>
                        </div>
                      </div>

                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <md-field>
                            <label for="xero_tracking">Xero Tracking Code</label>
                            <md-input
                              id="xero_tracking"
                              :disabled="!pageEditable"
                              v-model="xero_tracking_code.query"
                            />
                            <span class="md-suffix" v-if="xero_tracking_code.searching">
                              <md-progress-spinner
                                :md-diameter="30"
                                :md-stroke="3"
                                md-mode="indeterminate"></md-progress-spinner>
                            </span>
                          </md-field>
                          <v-data-table
                            v-if="xero_tracking_code.results && xero_tracking_code.query"
                            :items="xero_tracking_code.results"
                            :headers="xero_tracking_code_headers"
                            hide-default-header
                            item-key="id"
                            @click:row="handleCodeClick"
                            hide-default-footer
                            class="elevation-1"
                          />
                        </div>
                      </div>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <md-field>
                            <label for="broker-esign-id">E-Sign ID</label>
                            <md-input
                              id="broker-esign-id"
                              :disabled="true"
                              v-model="brokerData.broker_esign_id"
                            />
                          </md-field>
                        </div>
                      </div>
                    </group-card>
                    <br>
                    <group-card icon="details" padded>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <md-field>
                            <label for="target-field">Target</label>
                            <md-input
                              id="target-field"
                              :disabled="!pageEditable"
                              v-model="brokerData.target"
                            />
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <validated-text-input
                            label="ABN"
                            :disabled="!pageEditable"
                            v-model="brokerData.abn"
                            regex = "^(\d *?){11}$"
                            errormsg="Please enter a valid ABN, just spaces and 11 digits are allowed."
                          />
                        </div>
                        <div class="md-layout-item">
                          <validated-input
                            type="DATE"
                            label="Start Date"
                            :disabled="!pageEditable"
                            v-model="brokerData.start_date"
                          />
                        </div>
                        <div class="md-layout-item">
                          <validated-input
                            type="DATE"
                            label="End Date"
                            :disabled="!pageEditable"
                            v-model="brokerData.end_date"
                          />
                        </div>
                      </div>
                      <br>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <validated-input
                            type="DATE"
                            label="Grace Period End Date"
                            :disabled="!pageEditable"
                            v-model="brokerData.grace_period_end_date"
                          />
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="veda-rate-field">Veda Rate</label>
                            <md-input id="veda-rate-field" :disabled="!pageEditable"
                                      v-model="brokerData.veda_rate"/>
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="lead-rate-field">Lead Rate</label>
                            <md-input id="lead-rate-field" :disabled="!pageEditable"
                                      v-model="brokerData.lead_rate"/>
                          </md-field>
                        </div>
                      </div>
                      <br>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <md-field>
                            <label for="credit-rep-no-field">Credit Rep No</label>
                            <md-input id="credit-rep-no-field" :disabled="!pageEditable"
                                      v-model="brokerData.credit_rep_no"/>
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="rcti-enabled-field">RCTI Enabled</label>
                            <md-select
                              id="rcti-enabled-field"
                              :disabled="!pageEditable"
                              v-model="brokerData.rcti_enabled"
                            >
                              <md-option value="1">YES</md-option>
                              <md-option value="0">NO</md-option>
                            </md-select>
                          </md-field>
                        </div>
                      </div>
                      <br>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <md-field>
                            <label for="maclease_token_field">Maclease Token</label>
                            <md-input
                              id="maclease_token_field"
                              :disabled="!pageEditable"
                              v-model="brokerData.maclease_token"
                            />
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="maclease_id_field">Maclease ID</label>
                            <md-input
                              id="maclease_id_field"
                              :disabled="!pageEditable"
                              v-model="brokerData.maclease_id"
                            />
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="xeal_unique_id_field">Xeal Unique ID</label>
                            <md-input
                              id="xeal_unique_id_field"
                              :disabled="!pageEditable"
                              v-model="brokerData.xeal_unique_id"
                            />
                          </md-field>
                        </div>
                      </div>
                      <br>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <md-field>
                            <label for="pepper_code_field">Pepper Code</label>
                            <md-input
                              id="pepper_code_field"
                              :disabled="!pageEditable"
                              v-model="brokerData.pepper_code"
                            />
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="money3_id_field">Money3 ID</label>
                            <md-input
                              id="money3_id_field"
                              :disabled="!pageEditable"
                              v-model="brokerData.money3_id"
                            />
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="liberty_id_field">Liberty ID</label>
                            <md-input
                              id="liberty_id_field"
                              :disabled="!pageEditable"
                              v-model="brokerData.liberty_id"
                            />
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="latitude_id_field">Latitude ID</label>
                            <md-input
                              id="latitude_id_field"
                              :disabled="!pageEditable"
                              v-model="brokerData.latitude_id"/>
                          </md-field>
                        </div>
                      </div>
                      <br>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <md-field>
                            <label for="default-introducer-field">Default Referrer</label>
                            <md-input
                              id="default-introducer-field"
                              :disabled="!pageEditable"
                            />
                          </md-field>
                        </div>
                      </div>
                      <br>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item" v-for="items in brokerData.charge_setting" :key="items.id">
                          <md-checkbox v-model="items.is_enabled" :disabled="!pageEditable">{{ items.name }}</md-checkbox>
                        </div>
                      </div>
                    </group-card>
                    <br>
                  </md-card-content>
                </div>
                <div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
                  <md-card-content>
                    <group-card title="Triggers" icon="settings" padded>
                      <template slot="actions">
                        <span class="md-body-2 income-trigger-count">{{ customTriggerCountText }}</span>
                        <loading-icon-text-button
                          v-if="showIncomeTriggerButton"
                          icon="add"
                          :disabled="!pageEditable"
                          @click="configCustomTriggers"
                        >
                            Config Custom Trigger
                        </loading-icon-text-button>
                      </template>
                      <br>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <md-field>
                            <label for="trigger-one-field">Trigger 1</label>
                            <md-input id="trigger-one-field" :disabled="!pageEditable"
                                      v-model="brokerData.trigger_1"/>
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="rate-one-field">Rate 1</label>
                            <md-input id="rate-one-field" :disabled="!pageEditable"
                                      v-model="brokerData.rate_1"/>
                          </md-field>
                        </div>
                        <validated-autocomplete-input
                          class="md-layout-item"
                          label="Referrer 1"
                          v-model="brokerData.ref_name_1"
                          :options="administrationIntroducers.map(i => i.name)"
                          :disabled="!pageEditable"
                        />
                      </div>
                      <br>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <md-field>
                            <label for="trigger-two-field">Trigger 2</label>
                            <md-input id="trigger-two-field" :disabled="!pageEditable"
                                      v-model="brokerData.trigger_2"/>
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="rate-two-field">Rate 2</label>
                            <md-input id="rate-two-field" :disabled="!pageEditable"
                                      v-model="brokerData.rate_2"/>
                          </md-field>
                        </div>
                        <validated-autocomplete-input
                          class="md-layout-item"
                          label="Referrer 2"
                          v-model="brokerData.ref_name_2"
                          :options="administrationIntroducers.map(i => i.name)"
                          :disabled="!pageEditable"
                        />
                      </div>
                      <br>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <md-field>
                            <label for="trigger-three-field">Trigger 3</label>
                            <md-input id="trigger-three-field" :disabled="!pageEditable"
                                      v-model="brokerData.trigger_3"/>
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="rate-three-field">Rate 3</label>
                            <md-input id="rate-three-field" :disabled="!pageEditable"
                                      v-model="brokerData.rate_3"/>
                          </md-field>
                        </div>
                        <validated-autocomplete-input
                          class="md-layout-item"
                          label="Referrer 3"
                          v-model="brokerData.ref_name_3"
                          :options="administrationIntroducers.map(i => i.name)"
                          :disabled="!pageEditable"
                        />
                      </div>
                      <br>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <md-field>
                            <label for="trigger-four-field">Trigger 4</label>
                            <md-input id="trigger-four-field" :disabled="!pageEditable"
                                      v-model="brokerData.trigger_4"/>
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="rate-four-field">Rate 4</label>
                            <md-input id="rate-four-field" :disabled="!pageEditable"
                                      v-model="brokerData.rate_4"/>
                          </md-field>
                        </div>
                        <validated-autocomplete-input
                          class="md-layout-item"
                          label="Referrer 4"
                          v-model="brokerData.ref_name_4"
                          :options="administrationIntroducers.map(i => i.name)"
                          :disabled="!pageEditable"
                        />
                      </div>
                      <br>
                      <div class="md-layout md-gutter">
                        <div class="md-layout-item">
                          <md-field>
                            <label for="digital-trigger-field">Digital Trigger</label>
                            <md-input id="digital-trigger-field" :disabled="!pageEditable"
                                      v-model="brokerData.trigger_digital"/>
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="digital-rate-field">Digital Rate</label>
                            <md-input id="digital-rate-field" :disabled="!pageEditable"
                                      v-model="brokerData.rate_digital"/>
                          </md-field>
                        </div>
                        <div class="md-layout-item">
                          <md-field>
                            <label for="digital-ccrate-field">Digital CC Rate</label>
                            <md-input id="digital-ccrate-field" :disabled="!pageEditable"
                                      v-model="brokerData.rate_cc_digital"/>
                          </md-field>
                        </div>
                      </div>
                    </group-card>
                    <group-card title="Co-Branding" icon="branding_watermark" padded>
                      <md-subheader class="sub-header">
                        Ids
                      </md-subheader>
                      <div class="md-layout md-gutter">
                        <validated-number-input
                          class="md-layout-item"
                          label="Broker Hubspot Id"
                          v-model="brokerData.user.id"
                          :disabled="true"
                        />
                        <validated-text-input
                          class="md-layout-item"
                          label="Affiliate Id"
                          v-model="brokerData.hubspot.affiliate_id"
                          :disabled="!pageEditable"
                        />
                        <validated-autocomplete-input
                          class="md-layout-item"
                          label="Branding Type"
                          v-model="brokerData.hubspot.branding_type"
                          :options="hubspot_branding_types"
                          :disabled="!pageEditable"
                          :required = "pageEditable"
                          force
                        />
                      </div>
                      <br>
                      <md-subheader class="sub-header">
                          Broker
                      </md-subheader>
                      <div class="md-layout md-gutter">
                        <validated-text-input
                          class="md-layout-item"
                          label="Role"
                          v-model="brokerData.hubspot.role"
                          :disabled="!pageEditable"
                          alphaSpaces
                          regex="^\S+(?: \S+)*$"
                          errormsg="Please enter a valid role, It must only contain alphabetic characters. Space allowed between words."
                        />
                        <!-- Search Address -->
                        <search-address
                            :prefixLabel="prefixLabel"
                            :disabled="!pageEditable"
                            :address="brokerData.hubspot.address ? brokerData.hubspot.address : {}"
                            @update-address="updateAddress"
                        ></search-address>
                      </div>
                      <br>
                      <validated-text-input
                        class="md-layout-item"
                        label="Logo"
                        v-model="brokerData.hubspot.broker_logo"
                        :disabled="!pageEditable"
                        errormsg = "Field is required"
                      />
                      <br>
                      <md-subheader class="sub-header">
                          Page
                      </md-subheader>
                      <div class="md-layout md-gutter">
                          <validated-text-input
                            class="md-layout-item"
                            label="Qr code url"
                            v-model="brokerData.hubspot.qr_code_url"
                            :disabled="!pageEditable"
                            errormsg="Please enter a valid url. E.g: https://www.1800approved.com.au/"
                            url
                        />
                      </div>
                      <validated-text-input
                        class="md-layout-item"
                        label="Review link"
                        v-model="brokerData.hubspot.broker_review_link"
                        :disabled="!pageEditable"
                        errormsg = "Field is required"
                      />
                      <br>
                      <md-subheader class="sub-header">
                        Social Media Links
                      </md-subheader>
                      <div class="md-layout md-gutter">
                        <validated-text-input
                          class="md-layout-item"
                          label="Facebook Company Page"
                          v-model="brokerData.hubspot.facebook_url"
                          :disabled="!pageEditable"
                          errormsg = "Please enter a valid URL, eg https://www.ausloans.com.au"
                          url
                        />
                        <validated-text-input
                          class="md-layout-item"
                          label="Google Review Link"
                          v-model="brokerData.hubspot.google_review_link"
                          :disabled="!pageEditable"
                          errormsg = "Please enter a valid URL, eg https://www.ausloans.com.au"
                          url
                        />
                        <validated-text-input
                          class="md-layout-item"
                          label="Instagram Page"
                          v-model="brokerData.hubspot.instagram_url"
                          :disabled="!pageEditable"
                          errormsg = "Please enter a valid URL, eg https://www.ausloans.com.au"
                          url
                        />
                        <validated-text-input
                          class="md-layout-item"
                          label="Twitter Bio"
                          v-model="brokerData.hubspot.twitter_url"
                          :disabled="!pageEditable"
                          errormsg = "Please enter a valid URL, eg https://www.ausloans.com.au"
                          url
                        />
                        <validated-text-input
                          class="md-layout-item"
                          label="LinkedIn Page"
                          v-model="brokerData.hubspot.linkedin_url"
                          :disabled="!pageEditable"
                          errormsg = "Please enter a valid URL, eg https://www.ausloans.com.au"
                          url
                        />
                      </div>
                    </group-card>
                    <group-card title="Lender Credentials" icon="vpn_key" padded>
                      <template slot="actions">
                        <loading-icon-text-button
                          icon="add"
                          :disabled="!pageEditable"
                           @click="addCredential">
                            Add New
                        </loading-icon-text-button>
                      </template>
                      <div v-for="credential in brokerData.lender_credentials" class="md-layout boxed-category" padded v-if="credential" :key="credential.id">
                          <validated-select-input class="md-layout-item md-small-size-30 md-size-30" label="Lender"
                            v-model="credential.lender" :disabled="!pageEditable" :options="options.lenders"/>
                          <validated-text-input label="Username" class="md-layout-item md-small-size-30 md-size-30"
                            v-model="credential.username" :disabled="!pageEditable"/>
                          <validated-text-input label="password" class="md-layout-item md-small-size-30 md-size-30"
                            v-model="credential.password" :disabled="!pageEditable"/>
                        <loading-icon-button
                          :disabled="!pageEditable"
                          class="md-primary"
                          @click="removeCredential(credential)"
                          tooltip="Remove"
                        >
                          close
                        </loading-icon-button>
                      </div>
                    </group-card>
                  </md-card-content>
                </div>
              </form>
              <span>
                <md-button class="md-button md-raised md-primary"
                @click="$router.push('/administration/user_management/brokers')">
                    <md-icon>arrow_back</md-icon>
                </md-button>
                <md-tooltip md-direction="top">Back</md-tooltip>
              </span>

            <div class="button-div">
              <span>
                <md-button
                class="md-raised md-primary md-fab-bottom-right"
                v-if="pageEditable"
                :disabled="isSaving || invalid || !isMelissaCheckPassed"
                @click="saveBrokerDetails"
                >
                  <md-icon>save</md-icon>
                </md-button>
                <md-tooltip md-direction="top">Save</md-tooltip>
              </span>
              <md-progress-spinner
                :md-diameter="30"
                :md-stroke="3"
                md-mode="indeterminate"
                v-if="isSaving">
              </md-progress-spinner>
            </div>
            <div class="error-message" v-if="pageEditable && (invalid || !isMelissaCheckPassed)">
                <p>Errors have been highlighted above. Please enter valid data to save changes.</p>
            </div>
          </ValidationObserver>
        </group-card>

        <!--Income Trigger Dialog-->
        <income-trigger-configuration-dialog
          :show.sync="incomeTriggerDialog.show"
          :income-triggerable-type="incomeTriggerDialog.type"
          :income-triggerable-id="incomeTriggerDialog.id"
          @close-trigger-dialog="closeIncomeTriggerDialog"
        />

    </div>
</template>
<script>
import { GroupCard } from "@/components";
import filters from "@/components/utils/filters";
import { newBroker, newLenderCredential } from "@/schema.js";
import { mapGetters } from "vuex";
import ValidatedInputs from '@/components/ValidatedInput';
import LoadingIconTextButton from "../components/LoadingIconTextButton";
import LoadingIconButton from "../components/LoadingIconButton";
import ConfirmDialog from "../components/Dialogs/ConfirmDialog";
import SearchAddress from '@/components/SearchAddress.vue';
import IncomeTriggerConfigurationDialog from '../components/Dialogs/IncomeTrigger/IncomeTriggerConfigurationDialog.vue';

export default {
    components: {
      LoadingIconButton,
      LoadingIconTextButton,
      GroupCard,
      SearchAddress,
      ...ValidatedInputs,
      IncomeTriggerConfigurationDialog,
    },
    data() {
        let dateFormat = this.$material.locale.dateFormat || 'yyyy-MM-dd'
        return {
            hubspot_branding_types: ['Ausloans Branded Broker', 'Non Ausloans Broker'],
            brokerData: newBroker(),
            pageEditable: true,
            allPods: [],
            isSaving: false,
            snackbar: {
                show: false,
                icon: 'done',
                content: '',
            },
            brokerId: this.$route.params.broker_id,
            newApplication: false,
          xero_contacts: {
            query: "",
            searching: false,
            selected_contact: null,
          },
          xero_tracking_code: {
            query: "",
            searching: false,
            selected_code: null,
          },
          headers: [
            {text: 'Name', value: 'name'},
            {text: 'Email', value: 'email'},
            {text: 'Contact ID', value: 'contact_id'},
          ],
          xero_tracking_code_headers: [
            {text: 'Name', value: 'name'},
            {text: 'type', value: 'type'},
            {text: 'Tracking ID', value: 'tracking_id'},
          ],
          isMelissaCheckPassed: false,
          prefixLabel: '',
          incomeTriggerDialog: {
            show: false,
            id: null,
            type: "",
          },
        }
    },
    methods: {
        async getIntroducers() {
          try {
            await this.$store.dispatch('fetch_administration_introducers', false);
          } catch (e) {
            console.error('Error when fetch introducers');
          }
        },
        async removeCredential(credential){
          //if credential array is there in lender_credentials , remove it
          if (this.brokerData.lender_credentials.length > 0 ) {
            if (await this.showAlertDialog("Delete Credential?","Do you wish to delete the record?")) {
              //remove from db
              if (credential.id) {
                await axios.post(`/api/v1/administration/brokers/${credential.id}`);
              }
              this.brokerData.lender_credentials.splice(this.brokerData.lender_credentials.indexOf(credential), 1);
            }
          }
        },
        updateAddress(data) {
            try {
              if (data && data.full_address) {
                this.brokerData.hubspot.address = data;
              } else {
                console.error("Invalid data:", data);
              }
            } catch (error) {
              console.error("Error updating address:", error);
            }
        },
        addCredential() {
          this.brokerData.lender_credentials.push(new newLenderCredential());
        },
        async showAlertDialog(title, message) {
          return await this.$modal.show(ConfirmDialog,{
            title: title,
            message: message,
            confirmText: 'Continue',
            cancelText:'Close'
          });
          },
      async getBrokerDetails() {
            if (this.brokerId != undefined) {
                var brokerID = this.$route.params.broker_id;
                const response = await axios.get(`/api/v1/administration/brokers/${brokerID}`);
                // Parse unformatted_address field if it exists
                if (response.data && response.data.hubspot && response.data.hubspot.address) {
                    try {
                        response.data.hubspot.address = JSON.parse(response.data.hubspot.address);
                    } catch (error) {
                        console.error("Error parsing address JSON:", error);
                    }
                }
                this.brokerData = Object.assign(this.brokerData, response.data);
                this.xero_contacts.query = this.brokerData.xero_contact_id;
                this.xero_tracking_code.query = this.brokerData.xero_tracking_code;
                this.pageEditable = false;
            }
            this.getAllPods();
        },
        async saveBrokerDetails() {
            this.isSaving = true;
            try {
                const response = await axios.post('/api/v1/administration/brokers', this.brokerData)
                if (response.status == 200) {
                    this.snackbar = {
                        show: true,
                        icon: 'done',
                        content: 'Broker Details Saved'
                    }
                }
                this.isSaving = false;
                this.pageEditable = false;
                if (this.brokerId == undefined) {
                    this.$router.push(`/administration/user_management/broker/${response.data.id}/view`);
                }
            } catch (e) {
                this.snackbar = {
                    show: true,
                    icon: 'error',
                    content: e.response.data.errorInfo[2]
                }
                this.isSaving = false;
                this.pageEditable = false;
            }

        },
        async getAllPods() {
            const response = await axios.get('/api/v1/administration/user_pods')
            this.allPods = response.data;
        },
      async getXeroContacts() {
        if (this.xero_contacts.query !== null && this.xero_contacts.query.length > 2) {
          this.xero_contacts.searching = true;
          let { data } = await this.$store.dispatch('get_xero_contacts', this.xero_contacts.query);
          this.xero_contacts.results = data;
        }
        this.xero_contacts.searching = false;
      },
      async getXeroTrackingCodes() {
        if (this.xero_contacts.query !== null && this.xero_tracking_code.query.length > 2) {
          this.xero_tracking_code.searching = true;
          let { data } = await this.$store.dispatch('get_xero_tracking_code', this.xero_tracking_code.query);
          this.xero_tracking_code.results = data;
        }
        this.xero_tracking_code.searching = false;
      },
      handleClick(contact) {
        this.xero_contacts.query = contact.name;
        this.xero_contacts.selected_contact = contact.id;
        this.brokerData.xero_contact_id = contact.id;
      },
      handleCodeClick(code) {
        this.xero_tracking_code.query = code.tracking_id;
        this.xero_tracking_code.selected_contact = code.tracking_id;
        this.brokerData.xero_tracking_code = code.tracking_id;
      },
      resetFields() {
        this.xero_contacts.searching = false;
        this.xero_contacts.query = "";
        this.xero_contacts.selected_contact = null;
        this.xero_contacts.results = [];
      },
      updateMelissaCheck(isMelissaCheckVal) {
        this.isMelissaCheckPassed = isMelissaCheckVal;
      },
      configCustomTriggers() {
        this.incomeTriggerDialog.show = true;
        this.incomeTriggerDialog.id = parseInt(this.brokerId);
        this.incomeTriggerDialog.type = 'broker';
      },
      closeIncomeTriggerDialog (value) {
        this.incomeTriggerDialog.show = false;
        this.incomeTriggerDialog.id = null;
        this.incomeTriggerDialog.type = '';
        this.$set(this.brokerData, 'income_trigger_count', value);
      },
    },
    created() {
      this.getBrokerDetails();
      this.getIntroducers();
    },
    watch: {
      pageEditable: function (newVal) {
        if (newVal) {
          this.$refs.broker_email_input.validate();
          this.$refs.personal_email_input.validate();
        }
        return this.pageEditable
      },
      'xero_contacts.query'(){
        this.getXeroContacts();
      },
      'xero_tracking_code.query'(){
        this.getXeroTrackingCodes();
      },
      'brokerData.ref_name_1'() {
        const selected_intr = this.administrationIntroducers.find(introducer => {
          return introducer.name === this.brokerData.ref_name_1;
        })
        if (selected_intr) {
          this.brokerData.ref_id_1 = selected_intr.id;
        }
      },
      'brokerData.ref_name_2'() {
        const selected_intr = this.administrationIntroducers.find(introducer => {
          return introducer.name === this.brokerData.ref_name_2;
        })
        if (selected_intr) {
          this.brokerData.ref_id_2 = selected_intr.id;
        }
      },
      'brokerData.ref_name_3'() {
        const selected_intr = this.administrationIntroducers.find(introducer => {
          return introducer.name === this.brokerData.ref_name_3;
        })
        if (selected_intr) {
          this.brokerData.ref_id_3 = selected_intr.id;
        }
      },
      'brokerData.ref_name_4'() {
        const selected_intr = this.administrationIntroducers.find(introducer => {
          return introducer.name === this.brokerData.ref_name_4;
        })
        if (selected_intr) {
          this.brokerData.ref_id_4 = selected_intr.id;
        }
      },
    },
    filters: {
      ...filters,
    },
    computed: {
      ...mapGetters([
        'options',
      ]),
      administrationIntroducers() {
        let at = this.$store.getters.administrationIntroducers();
        return at.map(x => ({
          id: x.id,
          name: x.full_name,
        }));
      },
      broker_employment_types() {
          return Object.values(this.options.broker_employment_type);
      },
      address: {
        get() {
          return this.value;
        },
        set(address) {
          this.$emit('input', address);
        },
      },
      states() {
        return this.options.country_states.Australia;
      },
      showIncomeTriggerButton() {
        return this.brokerId != undefined
      },
      customTriggerCountText () {
        if (this.brokerData.income_trigger_count == 0 || this.brokerData.income_trigger_count == null) {
          return 'No Custom Triggers';
        }
        return '[' + this.brokerData.income_trigger_count + '] Custom Triggers'
      },
      allPodsOptions() {
        let data = [];

        this.allPods.forEach(pod => {
          if (data.indexOf(pod.name) === -1) {
            data.push(pod.name);
          }
        });

        return data;
      }
    },
    async beforeCreate() {
      const params = {
        types: [
          'broker_employment_type',
          'country_states',
          'lenders',
        ],
      }
      await this.$store.dispatch('fetch_types', { params });
    },
}
</script>
<style scoped lang="scss">

@import "../assets/scss/md-custom/_ausloans-colors.scss";
.sub-header {
  background-color: $ausloans-blue-light !important;
  border-radius: 5px;
  margin-bottom: 15px;
  color: white;
}

.float-right {
    width: 32%;

    .md-title {
        text-align: center;
    }
}

.error-message {
  text-align: center;
  padding: 30px 0px;
  color: red;
  font-size: 20px;
  font-weight: 600;
}

.button-div {
    float: right;
}

.income-trigger-count {
  margin-right: 20px;
  margin-top: 15px;
}

</style>
